var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurvey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-label": "Anket",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sv-face",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5FE6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#17B3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B7F72"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sv-inner",
    cx: 0.42,
    cy: 0.3,
    r: 0.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3FD3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E9787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sv-gloss",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sv-board",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3D5A86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2E4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sv-paper",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EDF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sv-clipm",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F6F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3AEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sv-ok",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6BEA86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9A45"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "sv-bsh",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "sv-osh",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "170%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 8,
    floodColor: "#023B34",
    floodOpacity: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sv-clip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.0,44.0 A46.3,46.3 0 0 1 337.1,60.1 A46.3,46.3 0 0 1 405.9,106.1 A46.3,46.3 0 0 1 451.9,174.9 A46.3,46.3 0 0 1 468.0,256.0 A46.3,46.3 0 0 1 451.9,337.1 A46.3,46.3 0 0 1 405.9,405.9 A46.3,46.3 0 0 1 337.1,451.9 A46.3,46.3 0 0 1 256.0,468.0 A46.3,46.3 0 0 1 174.9,451.9 A46.3,46.3 0 0 1 106.1,405.9 A46.3,46.3 0 0 1 60.1,337.1 A46.3,46.3 0 0 1 44.0,256.0 A46.3,46.3 0 0 1 60.1,174.9 A46.3,46.3 0 0 1 106.1,106.1 A46.3,46.3 0 0 1 174.9,60.1 A46.3,46.3 0 0 1 256.0,44.0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(256 250) scale(0.9) translate(-256 -256)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 16)",
    fill: "#023B34",
    opacity: 0.38,
    filter: "url(#sv-bsh)",
    d: "M256.0,44.0 A46.3,46.3 0 0 1 337.1,60.1 A46.3,46.3 0 0 1 405.9,106.1 A46.3,46.3 0 0 1 451.9,174.9 A46.3,46.3 0 0 1 468.0,256.0 A46.3,46.3 0 0 1 451.9,337.1 A46.3,46.3 0 0 1 405.9,405.9 A46.3,46.3 0 0 1 337.1,451.9 A46.3,46.3 0 0 1 256.0,468.0 A46.3,46.3 0 0 1 174.9,451.9 A46.3,46.3 0 0 1 106.1,405.9 A46.3,46.3 0 0 1 60.1,337.1 A46.3,46.3 0 0 1 44.0,256.0 A46.3,46.3 0 0 1 60.1,174.9 A46.3,46.3 0 0 1 106.1,106.1 A46.3,46.3 0 0 1 174.9,60.1 A46.3,46.3 0 0 1 256.0,44.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 8)",
    fill: "#066459",
    d: "M256.0,44.0 A46.3,46.3 0 0 1 337.1,60.1 A46.3,46.3 0 0 1 405.9,106.1 A46.3,46.3 0 0 1 451.9,174.9 A46.3,46.3 0 0 1 468.0,256.0 A46.3,46.3 0 0 1 451.9,337.1 A46.3,46.3 0 0 1 405.9,405.9 A46.3,46.3 0 0 1 337.1,451.9 A46.3,46.3 0 0 1 256.0,468.0 A46.3,46.3 0 0 1 174.9,451.9 A46.3,46.3 0 0 1 106.1,405.9 A46.3,46.3 0 0 1 60.1,337.1 A46.3,46.3 0 0 1 44.0,256.0 A46.3,46.3 0 0 1 60.1,174.9 A46.3,46.3 0 0 1 106.1,106.1 A46.3,46.3 0 0 1 174.9,60.1 A46.3,46.3 0 0 1 256.0,44.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sv-face)",
    d: "M256.0,44.0 A46.3,46.3 0 0 1 337.1,60.1 A46.3,46.3 0 0 1 405.9,106.1 A46.3,46.3 0 0 1 451.9,174.9 A46.3,46.3 0 0 1 468.0,256.0 A46.3,46.3 0 0 1 451.9,337.1 A46.3,46.3 0 0 1 405.9,405.9 A46.3,46.3 0 0 1 337.1,451.9 A46.3,46.3 0 0 1 256.0,468.0 A46.3,46.3 0 0 1 174.9,451.9 A46.3,46.3 0 0 1 106.1,405.9 A46.3,46.3 0 0 1 60.1,337.1 A46.3,46.3 0 0 1 44.0,256.0 A46.3,46.3 0 0 1 60.1,174.9 A46.3,46.3 0 0 1 106.1,106.1 A46.3,46.3 0 0 1 174.9,60.1 A46.3,46.3 0 0 1 256.0,44.0 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 178,
    fill: "#076C61",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 252,
    r: 174,
    fill: "url(#sv-inner)",
    stroke: "#FFFFFF",
    strokeOpacity: 0.5,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sv-clip)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 118,
    rx: 210,
    ry: 112,
    fill: "url(#sv-gloss)",
    opacity: 0.55
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#sv-osh)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 154,
    width: 172,
    height: 226,
    rx: 20,
    fill: "#142440"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 146,
    width: 172,
    height: 226,
    rx: 20,
    fill: "url(#sv-board)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 174,
    width: 136,
    height: 180,
    rx: 8,
    fill: "url(#sv-paper)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 200,
    width: 26,
    height: 26,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#17B3A3",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,213 L216,219 L226,206",
    fill: "none",
    stroke: "#0E9787",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 208,
    width: 70,
    height: 10,
    rx: 5,
    fill: "#C6D0DD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 244,
    width: 26,
    height: 26,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#17B3A3",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,257 L216,263 L226,250",
    fill: "none",
    stroke: "#0E9787",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 252,
    width: 58,
    height: 10,
    rx: 5,
    fill: "#C6D0DD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 288,
    width: 26,
    height: 26,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#B5C0CF",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 296,
    width: 46,
    height: 10,
    rx: 5,
    fill: "#C6D0DD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 128,
    width: 84,
    height: 42,
    rx: 12,
    fill: "url(#sv-clipm)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 133,
    width: 68,
    height: 8,
    rx: 4,
    fill: "#FFFFFF",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 148,
    r: 7,
    fill: "#1C2E4E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 158,
    width: 10,
    height: 200,
    rx: 5,
    fill: "#FFFFFF",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336,
    cy: 334,
    r: 48,
    fill: "url(#sv-ok)",
    stroke: "#FFFFFF",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 324,
    cy: 312,
    rx: 22,
    ry: 11,
    fill: "#FFFFFF",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,335 L330,351 L360,319",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/survey.d52e93f101c1274e8793b68ca179780b.svg";
export { ForwardRef as ReactComponent };